module.exports = __webpack_public_path__ + "static/img/3059_phase_function_Paper_Points.b4ceca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3059_phase_function_Paper_Points.png
// module id = MevZ
// module chunks = 0